import React from 'react';
import PropTypes from 'prop-types';

import { propTypes as linkPropTypes } from '../../../../01_atoms/Link';
import IconStat from '../../../../02_molecules/IconStat';
import FrayedContainer from '../../../../02_molecules/FrayedContainer';
import {
  behaviorSettingsProps,
  generateClassNameByBehaviorSettings,
} from '../../../../../utils/behaviorSettings';

import styles from './index.module.scss';

const BBCTASecondary = ({ title = '', contents, behaviorSettings = null, uuid = null }) => (
  <div
    className={`bb ${styles['bb-cta-secondary']} ${generateClassNameByBehaviorSettings(behaviorSettings)}`}
    data-component="bb-cta-secondary"
    id={uuid}
  >
    <FrayedContainer title={title}>
      <div className={`${styles['bb-cta-secondary__container']}`}>
        {contents.map((link, i) => (
          <IconStat
            key={`bb-other-ways-to-help-${i}`}
            iconURL={link.iconURL}
            title={link.cta}
            description={link.description}
            nextLink={link.nextLink}
            className={`${styles['bb-cta-secondary__link']}`}
          />
        ))}
      </div>
    </FrayedContainer>
  </div>
);

BBCTASecondary.propTypes = {
  title: PropTypes.string,
  contents: PropTypes.arrayOf(
    PropTypes.shape({
      iconURL: PropTypes.string,
      cta: PropTypes.string,
      description: PropTypes.string,
      nextLink: PropTypes.shape(linkPropTypes),
    }),
  ).isRequired,
  behaviorSettings: behaviorSettingsProps,
  uuid: PropTypes.string,
};

export default BBCTASecondary;
